<template>
    <!--<div class="reccuring-container">
        <div class="toggle-h5">
            <h5 style="font-weight: 500;font-size: large;">Recurring Invoices</h5>
            <label class="toggle">
                <span class="toggle-label">Off</span>
                <input type="checkbox" class="toggle-input" v-model="isRecurringEnabled" @change="handleToggleChange">
                <span class="toggle-switch"></span>
                <span class="toggle-label">On</span>
            </label>
        </div>
        <label style="opacity: 50%;font-size: 15px; margin-top: 0.7rem;">Recurring invoices will be automatically
            generated and sent based on your selected frequency</label>
        <div style="margin-top: 1rem;">
            <div class="cc-email-container">
                <input class="input-class" type="email" disabled>
                <button class="rem-cc">×</button>
            </div>
            <label style="color:blue; margin-top: 0.5rem;" class="add-email">+ Add
                Email</label>
        </div>
        <vue3-select class="vue3-select" :options="reportPeriods" placeholder="Select option" />
        <div style="margin-top: 1.5rem;">
            <input type="checkbox" id="usage" name="Usage Report">
            <label for="Usage" style="margin-left: 0.4rem;">Usage Report</label>
            <input style="margin-left: 1.5rem;" type="checkbox" id="invoices" name="Invoices Report">
            <label for="invoices" style="margin-left: 0.4rem;">Invoices Report</label>
        </div>
        <div style="height: 4rem">
            <button class="save-btn">Save</button>
            <button class="cancel-btn">Cancel</button>
        </div>
    </div> -->

    <!-- second big card -->
    <div class="reccuring-container">
        <h5 style="font-weight: 500;font-size: large;">Download payment history of your business</h5>
        <label style="opacity: 50%;font-size: 15px; margin-top: 0.7rem;width: 90%">A new improved version of invoices
            and usage reports is now available
            for you to download. You can now select the specific date range for which you would like to see the
            report.
        </label>
        <div class="mt-4">
            <div class="mx-2 mb-3" :class="this.lastMonthStatus ? 'primary-button' : 'secondary-button'"
                @click="SetTime(1)">
                Last Month
            </div>
            <div class="mx-2 mb-3" :class="this.last3Months ? 'primary-button' : 'secondary-button'"
                @click="SetTime(2)">
                Last 3 Months
            </div>
            <div class="mx-2 mb-3" :class="this.last6Months ? 'primary-button' : 'secondary-button'"
                @click="SetTime(3)">
                Last 6 Months
            </div>
            <div class="mx-2 mb-3" :class="this.lastYear ? 'primary-button' : 'secondary-button'" @click="SetTime(4)">
                Last 1 Year
            </div>
            <div class="mx-2 mb-3" :class="this.customStatus ? 'primary-button' : 'secondary-button'"
                @click="CustomTimeFilter()">
                Custom Range
            </div>
            <div class="mt-4 p-4" style="background-color:#F9FAFB; border-radius: 24px;" v-if="this.customStatus">
                <h5 style="font-weight: 600;">Custom Date Range</h5>
                <div class="row mt-4">
                    <div class="col-md-3 form-group mb-3">
                        <label class="input-hero" for="fromDate">
                            <input type="date" v-model="inputFromDate" class="input_area" id="fromDate"
                                :max="maxDateTime">
                            <span class="input-name">From Date<span class="text-danger">*</span></span>
                        </label>
                    </div>
                    <div class="col-md-3 form-group mb-3">
                        <label class="input-hero" for="toDate">
                            <input type="date" v-model="inputToDate" class="input_area" id="toDate" :max="maxDateTime">
                            <span class="input-name">To Date<span class="text-danger">*</span></span>
                        </label>
                    </div>
                    <div class="col-md-3">
                        <button class="btn btn-primary me-3 mb-3" type="button" @click="selectedCustomTime()">
                            Check
                        </button>
                    </div>

                </div>
            </div>
            <div class="table-container">
                <div>
                    <label style="font-weight: bold;">Invoices</label>
                    <span style="margin-left: 0.5rem;">[{{ fancyStartDate }} - {{ fancyEndDate }}]</span>
                    <!-- <i class="bi bi-pencil-square" style="color: blue;margin-left: 0.7rem;"></i> -->
                    <!-- <span style="color: blue; margin-left: 33rem;"><i class="bi bi-fullscreen"
                            style="color: blue;margin-right: 0.5rem;"></i> View all invoices</span> -->
                </div>
                <div v-if="invoiceData.length == 0" class="mt-4" style="color: red;">No data available for selected time
                    period.</div>
                <table v-else
                    style="width: 100%; margin-top: 1.5rem; text-align: center;margin-right: 1rem;border: 1px solid #EBEFF3; border-collapse: collapse; overflow-x:auto">
                    <tr style="background: #E7EAEF;padding:3px;height:2.5rem">
                        <td>Invoice No.</td>
                        <td>Issued date</td>
                        <td>Due date</td>
                        <td>Status</td>
                        <td>Amount</td>
                        <td>Balance Amount</td>
                        <td>Download</td>
                        <td>Payment</td>
                    </tr>
                    <tbody v-for="item in paginatedInvoiceData" :key="item">
                        <tr>
                            <td style="padding: 10px">{{ item.invoice_number }}</td>
                            <td>{{ dateConvert(item.invoice_date) }}</td>
                            <td>{{ dateConvert(item.due_date) }}</td>
                            <td>
                                <span class="View-Candidates-xmark" style="color: red;"
                                    v-if="this.invoiceStatusLowerCase(item.status) == 'overdue'">
                                    <i class="fa-solid fa-clock-rotate-left me-2"></i>Overdue by
                                    {{ CheckStatus(item.due_date) }} days</span>
                                <span class="View-Candidates-clock" style="color:#ff9900"
                                    v-else-if="this.invoiceStatusLowerCase(item.status) == 'pending'">
                                    <i class="fa-solid fa-clock-rotate-left me-2"></i>Pending</span>
                                <span class="View-Candidates-clock" style="color:#ff9900"
                                    v-else-if="this.invoiceStatusLowerCase(item.status) == 'draft'">
                                    <i class="fa-regular fa-note-sticky me-2"></i>Draft</span>
                                <span class="View-Candidates-pass" style="color:#048848"
                                    v-else-if="this.invoiceStatusLowerCase(item.status) == 'paid'">
                                    <i class="fa-solid fa-check me-2"></i>Paid</span>
                                <span class="View-Candidates-pass" style="color:#ff9900"
                                    v-else-if="this.invoiceStatusLowerCase(item.status) == 'partiallypaid'">
                                    <i class="fa-solid fa-check me-2"></i>Partially Paid</span>
                                <span class="View-Candidates-xmark" style="color:#cf1902"
                                    v-else-if="this.invoiceStatusLowerCase(item.status) == 'unpaid'">
                                    <i class="fa-solid fa-clock-rotate-left me-2"></i>Unpaid</span>
                                <span class="Invoice-sent" style="color:#17a4fc"
                                    v-else-if="this.invoiceStatusLowerCase(item.status) == 'sent'">
                                    <i class="fa-solid fa-check me-2"></i>Sent</span>
                                <span class="View-Candidates-xmark" style="color:#ff9900"
                                    v-else-if="this.invoiceStatusLowerCase(item.status) == 'void'">
                                    <i class="fa-solid fa-check me-2"></i>Void</span>

                            </td>
                            <td>{{ item.total }} /-</td>
                            <td>{{ item.balance }} /-</td>
                            <td style=" cursor: pointer;" @click="downloadInvoice(item.invoice_id, item.invoice_number)"
                                v-if="checkDownloadStatus(item.status)">
                                <i class="bi bi-download" style="color:blue"></i>
                            </td>
                            <td>
                                <button v-if="invoiceIds.includes(item.invoice_id)" class="pay-btn"
                                    @click="payNow(item.invoice_id)">Pay Now</button>
                                <span v-else>-</span>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <!-- <div class="float-end" style="height: 4rem; margin-top: 1.5rem;">
                <button class="save-btn">Download</button>
                <button class="cancel-btn">Cancel</button>
                Pagination here
            </div> -->
            <div class="pagination-container" v-if="totalPages > 1">
                <button class="pagination-button" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
                    Previous
                </button>
                <button v-for="page in totalPages" :key="page" class="pagination-button"
                    :class="{ 'active-page': currentPage === page }" @click="changePage(page)">
                    {{ page }}
                </button>
                <button class="pagination-button" @click="changePage(currentPage + 1)"
                    :disabled="currentPage === totalPages">
                    Next
                </button>
            </div>
        </div>

    </div>
</template>

<script>
// import "vue3-select/dist/vue3-select.css";
// import Vue3Select from "vue3-select";
import { mapActions, mapState } from "vuex";
import moment from "moment";

export default {
    name: "PaymentHistoryContent",
    components: {
        // Vue3Select,
    },
    data() {
        return {
            isRecurringEnabled: false,
            reportPeriods: ['Annually', 'Monthly', 'Quarterly'],

            invoiceShow: true,

            fromDate: '',
            toDate: '',

            //for tabs:
            last3Months: false,
            lastMonthStatus: true,
            customStatus: false,
            last6Months: false,
            lastYear: false,

            inputFromDate: "",
            inputToDate: "",

            invoiceIds: [],
            invoiceData: [],
            currentPage: 1,  
            recordsPerPage: 10
        }
    },
    methods: {
        ...mapActions(['GetEnterpriseInvoiceData', 'DownloadInvoice', 'ShowWarningMessage', 'GetPaymentLinkByInvoiceId']),
        handleToggleChange() {
            console.log('Recurring invoices:', this.isRecurringEnabled ? 'Enabled' : 'Disabled');
        },
        async GetInvoice() {
            var enterpriseInvoice = await this.GetEnterpriseInvoiceData({
                clientId: this.user.clientId, //this.user.clientId , 2726
                startDate: this.fromDate,
                EndDate: this.toDate,
            });
            this.invoiceData = enterpriseInvoice != undefined ? enterpriseInvoice.object.data : [];
            if (this.user.clientId != 1001) {
                this.invoiceData = this.invoiceData.filter(invoice => invoice.status.toLowerCase() !== 'draft');
            }
            var paymentGenerationInvoices = this.invoiceData.filter(invoice => invoice.status.toLowerCase() == 'sent'
                || invoice.status.toLowerCase() == 'unpaid' || invoice.status.toLowerCase() == 'partiallypaid'
                || invoice.status.toLowerCase() == 'overdue' || invoice.status.toLowerCase() == 'pending');
            this.invoiceIds = paymentGenerationInvoices.map(inv => inv.invoice_id)

            console.log("inv data", this.invoiceData)
        },
        CheckStatus(dueDate) {
            let currentDate = new Date();
            let due_date = new Date(dueDate);
            let diff = due_date.getTime() - currentDate.getTime();
            let days = Math.ceil(diff / (1000 * 60 * 60 * 24));
            this.Remainingdays = Math.abs(days);
            return this.Remainingdays;
        },
        dateConvert: function (value) {
            return moment(String(value)).format("DD/MM/YYYY");
        },
        checkDownloadStatus(status) {
            const lowerStatus = this.invoiceStatusLowerCase(status);
            return lowerStatus !== 'draft' && lowerStatus !== 'void';
        },
        invoiceStatusLowerCase(item) {
            return item.toLowerCase();
        },
        async downloadInvoice(id, invoiceNumber) {
            await this.DownloadInvoice({
                invoiceId: id,
                invoiceNumber: invoiceNumber
            })
        },
        async SetTime(value) {
            this.ResetStatus();
            switch (value) {
                case 1:
                    this.fromDate = moment().subtract(1, 'months').startOf('month').format("YYYY-MM-DD");
                    this.toDate = moment().subtract(1, 'months').endOf('month').format("YYYY-MM-DD");
                    this.lastMonthStatus = true;
                    this.GetInvoice();
                    break;
                case 2:
                    this.fromDate = moment().subtract(3, 'months').startOf('month').format("YYYY-MM-DD");
                    this.toDate = moment().subtract(1, 'months').endOf('month').format("YYYY-MM-DD");
                    this.last3Months = true;
                    this.GetInvoice();
                    break;
                case 3:
                    this.fromDate = moment().subtract(6, 'months').startOf('month').format("YYYY-MM-DD");
                    this.toDate = moment().subtract(1, 'months').endOf('month').format("YYYY-MM-DD");
                    this.last6Months = true;
                    this.GetInvoice();
                    break;
                case 4:
                    this.fromDate = moment().subtract(12, 'months').startOf('month').format("YYYY-MM-DD");
                    this.toDate = moment().subtract(1, 'months').endOf('month').format("YYYY-MM-DD");
                    this.lastYear = true;
                    this.GetInvoice();
                    break;
                default:
                    this.fromDate = moment().subtract(1, 'months').startOf('month').format("YYYY-MM-DD");
                    this.toDate = moment().startOf('month').format("YYYY-MM-DD");
                    this.lastMonthStatus = true;
                    this.GetInvoice();
                    break;
            }

        },
        ResetStatus() {
            this.last3Months = false;
            this.lastMonthStatus = false;
            this.customStatus = false;
            this.last6Months = false;
            this.lastYear = false;
        },
        CustomTimeFilter() {
            this.ResetStatus();
            this.customStatus = true;
        },
        selectedCustomTime() {
            const date = new Date();
            if (this.inputFromDate === '' || this.inputToDate === '') {
                return this.ShowWarningMessage("Dates cant be empty")
            }
            if (this.inputFromDate >= this.inputToDate) {
                return this.ShowWarningMessage("From Date can't be greater than To Date");
            }
            else if (this.inputFromDate > date || this.inputToDate > date) {
                return this.ShowWarningMessage("Date can't be greater than Current Date");
            } else if (this.inputFromDate < '2000-01-01') {
                return this.ShowWarningMessage("From Date should be after the year 2000");
            } else if (this.inputToDate > '2050-01-01') return this.ShowWarningMessage("To Date should be before the year 2050");


            this.fromDate = moment(this.inputFromDate).format("YYYY-MM-DD");
            this.toDate = moment(this.inputToDate).format("YYYY-MM-DD");
            this.GetInvoice();
        },
        async payNow(invoiceId) {
            try {
                const response = await this.GetPaymentLinkByInvoiceId({ invoice_id: invoiceId });
                if (response.status) {
                    const paymentLink = response.object.data.hostedpage.url;
                    if (paymentLink) window.open(paymentLink, '_self');
                } else {
                    this.ShowWarningMessage('Failed to get payment link');
                }
            } catch (error) {
                console.error('Error getting payment link:', error);
                this.ShowWarningMessage('An error occurred while getting the payment link');
            }
        },
        changePage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
        }
    },
    async mounted() {
        this.fromDate = moment().subtract(1, 'months').startOf('month').format("YYYY/MM/DD");
        this.toDate = moment().subtract(1, 'months').endOf('month').format("YYYY/MM/DD");
        // console.log(this.fromDate)
        // console.log(this.toDate)
        await this.GetInvoice();
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
        fancyEndDate() {
            return moment(this.toDate, "YYYY/MM/DD").format("Do MMMM YYYY");
        },
        fancyStartDate() {
            return moment(this.fromDate, "YYYY/MM/DD").format("Do MMMM YYYY");
        },
        totalPages() {
            return Math.ceil(this.invoiceData.length / this.recordsPerPage);
        },
        paginatedInvoiceData() {
            const start = (this.currentPage - 1) * this.recordsPerPage;
            const end = start + this.recordsPerPage;
            return this.invoiceData.slice(start, end);
        }
    }
}
</script>

<style scoped>
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  gap: 0.5rem;
}

.pagination-button {
  background-color: white;
  color: #4F46E5; /* Example color, adjust to your theme */
  border: 2px solid #4F46E5;
  border-radius: 5px;
  padding: 0.375rem 0.75rem;
  cursor: pointer;
  transition: background 0.3s ease;
}

.pagination-button:hover {
  background-color: #a9aaff;
  color: white;
}

.pagination-button.active-page {
  background-color: #4F46E5;
  color: white;
}

.pagination-button:disabled {
  background-color: #e0e0e0;
  color: #666;
  cursor: not-allowed;
}

.reccuring-container {
    padding: 1rem 1rem;
    background-color: white;
    margin-left: 2rem;
    border-radius: 6px;
    margin-top: 2rem;
    width: 93%;
    box-shadow: 0 1px 3px rgba(101, 101, 101, 0.3);
}

.toggle-container {
    display: flex;
    align-items: center;
    gap: 15px;
}

.toggle {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #666;
}

.toggle-switch {
    position: relative;
    width: 40px;
    height: 20px;
    background: #e0e0e0;
    border-radius: 20px;
    cursor: pointer;
    transition: background 0.3s ease;
}

.toggle-switch::before {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    background: blue;
    border-radius: 50%;
    transition: transform 0.3s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.toggle-input {
    display: none;
}

.toggle-input:checked+.toggle-switch {
    background: #a9aaff;
}

.toggle-input:checked+.toggle-switch::before {
    transform: translateX(20px);
}

.toggle-label {
    font-weight: 400;
    user-select: none;
}

.toggle-h5 {
    display: flex;
    justify-content: space-between;
}

.input-class {
    border: 2px solid;
    border-radius: 5px;
    border-color: rgba(128, 128, 128, 0.5);
    padding: 5px 7px;
    width: 35%;
    margin-top: 0.8rem;
}

.rem-cc {
    color: red;
    margin-left: 0.5rem;
    background: transparent;
    border: none
}

.vue3-select {
    border: 1px solid;
    border-radius: 5px;
    border-color: rgba(128, 128, 128, 0.5);
    width: 35%;
    margin-top: 0.9rem;
    background-color: white;
}

.save-btn {
    background: #4F46E5;
    color: white;
    width: 8rem;
    border-radius: 6px;
    border: none;
    padding: 7px 0px;
    font-size: large;
    float: inline-end;
    margin-left: 1rem;
    margin-top: 0.7rem;
}

.cancel-btn {
    background-color: #cdcdcd;
    border: none;
    border-radius: 6px;
    width: 8rem;
    float: inline-end;
    padding: 7px 0px;
    font-size: large;
    margin-top: 0.7rem;
}

.primary-button {
    background-color: #4F46E5;
    font-size: medium !important;
    border-radius: 5px;
    color: #FFFFFF;
    border: 2px solid #4F46E5 !important;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    padding: 0.375rem 0.75rem;
    cursor: pointer;
}

.secondary-button {
    font-size: medium !important;
    font-weight: 500;
    border-radius: 5px;
    color: #4F46E5;
    border: 2px solid #4F46E5 !important;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    padding: 0.375rem 0.75rem;
    cursor: pointer;
}

.table-container {
    background-color: #33333308;
    padding: 1rem;
    border-radius: 2px;
    margin-right: 1.5rem;
    margin-left: 1.5rem;
    margin-top: 1.5rem;
}

.pay-btn {
    border-radius: 5px;
    border: none;
    background: #17a4fc;
    color: white;
    padding: 5px;
}

.pay-btn:hover {
    background: #4F46E5;
}

@media (max-width: 480px) {
    .table-container {
        overflow-x: scroll;
    }
}
</style>